import { useEffect, useState } from "react";
import { useAppContext } from "../../libs/app-core/AppContext";
import { OnApiError } from "../ErrorManager";
import { UniFunc } from "./UniFunc";
import { DAO } from "./DAO";
import { API, ApiResult } from "./API";
import { WS } from "./WS";

export class UniFuncDAO {

  static async FetchByGuid(guid: string): Promise<UniFunc> {
    let data = await DAO.FetchByGuid(UniFunc, guid);
    return data;
  }

  static async Select(): Promise<UniFunc[]> {
    let cond = " WHERE (1=1) "
      + Cnd.OrderBy預設排序();

    let data_list = await DAO.Select(UniFunc, cond);
    return data_list;
  }
  static async WS_SelectALL(): Promise<UniFunc[]> {
    let api_rslt: ApiResult = await WS.CallWS(
      "uni_func/select_all",
      undefined
    );

    if (api_rslt.code === API.CODE_OK) {
      return API.ToClassList(UniFunc, api_rslt.data);
    } else {
      throw new Error(`API Error: ${api_rslt.code} ${api_rslt.message} !!!`);
    }
  }

}

class Cnd {

  static OrderBy預設排序() {
    return ` ORDER BY func_code, func_title, serno `;
  }
}
export function useUniFunc(guid: string) {
  const ctx = useAppContext();

  const [_UniFunc, set_UniFunc] = useState<UniFunc | null>(null);

  async function refresh_UniFunc() {
    try {
      const data_list = await UniFuncDAO.FetchByGuid(guid);
      set_UniFunc(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniFunc();
  }, [guid]);

  return { _UniFunc, set_UniFunc, refresh_UniFunc }
}


export function useUniFuncList() {
  const ctx = useAppContext();

  const [_UniFuncList, set_UniFuncList] = useState<UniFunc[]>([]);

  async function refresh_UniFuncList() {
    try {
      const data_list = await UniFuncDAO.Select();
      set_UniFuncList(data_list);
    } catch (ex: any) {
      OnApiError(ctx, ex);
      return;
    }
  };

  useEffect(() => {
    refresh_UniFuncList();
  }, []);

  return { _UniFuncList, set_UniFuncList, refresh_UniFuncList }
}